import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  toggleBottomBar: {
    width: 600,
    height: 48,
    position: 'absolute',
    bottom: 40,
    left: 48,
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: 8,
    borderRadius: 16,
    marginLeft: 24,
  },
  toggleButton: {
    border: 'none',
    marginLeft: 16,
    background: 'transparent',
    '& :hover': {
      opacity: 0.9,
    },
  },
  toggleOrderButtonContainer: {
    display: 'flex',
    flex: 1,
  },
  toggleOrderButton: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    border: 'none',
    background: 'transparent',
    marginLeft: 8,
    marginRight: 8,
  },
  buttonText: {
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
  },
}));
